import React from "react";
import "../designcss/Helpingbusiness.css";

const Audiencegrowsmartercard = () => {
  return (
    <div className="business-wrapper">
      <div className="business-container">
        <div className="grows-smarter">
          <h1>Understanding Audience Targeting</h1>
          <h1>on WhatsApp</h1>
        </div>

        <p className="business-api">
          Audience targeting involves grouping customers based on factors like
          demographics, behavior, purchase history, interests, and engagement
          levels. Instead of broadcasting the same message to everyone.
        </p>

        <div className="vision-mission-container">
          <div className="cardd vision-card">
            <h3>The Importance of Audience Targeting for Businesses</h3>
            <p>
              WoSender helps brands plan and scale WhatsApp communication
              effortlessly. From official WhatsApp API integration to bulk
              messaging, automation, and performance insights, the platform
              ensures secure, compliant messaging with high delivery success.
            </p>
          </div>

          <div className="cardd mission-card">
            <h3>How WoSender Enables Precise Audience Segmentation</h3>
            <p>
              WoSender empowers businesses to identify, segment, and engage
              their audience with accuracy. With advanced filters, automated
              messaging flows, and real-time analytics, brands can run highly
              personalized campaigns at scale while keeping interactions
              relevant and meaningful.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Audiencegrowsmartercard;
